const requireAuth = (to, from, next) => {
  const user = JSON.parse(localStorage.getItem('user'));
  const token = localStorage.getItem('token');
  const role = localStorage.getItem('role');
  if (user && token && role) {
    next();
  } else {
    next('/login');
  }
};

export default requireAuth;
